///index/game/banner
import axiosInstance from '../axiosInstance';
//banner
export function gameBanners () {
    return axiosInstance.get('/index/game/banner');
}
//系统配置
export function systemConfig () {
    return axiosInstance.get('/index/game/config');
}